import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import Button from "../Button/Button";
import Fi from "../Field/Fi";
import FormControlLabel from "@mui/material/FormControlLabel";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CountriesModal from "./CountriesModal";
import MenuItem from "@mui/material/MenuItem";
import useDraggableScroll from "use-draggable-scroll";

const price = ["100", "200", "300", "400"];
const capacity = ["100", "200", "300", "400"];
const height = ["100", "200", "300", "400"];
const weight = ["100", "200", "300", "400"];

export default function MoreFilterModal({
  open,
  setOpen,
  resetFilter,
  setReset,
}) {
  const ref = React.useRef(null);
  const { onMouseDown } = useDraggableScroll(ref, { direction: "horizontal" });
  const [countriesModal, setCountriesModal] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [keyword, setKeyword] = React.useState("");
  const [keywords, setKeywords] = React.useState([]);
  const [selectedCountries, setSelectedCountries] = React.useState([]);
  const [minPrice, setMinPrice] = React.useState("");
  const [maxPrice, setMaxPrice] = React.useState("");
  const [minCapacity, setMinCapacity] = React.useState("");
  const [maxCapacity, setMaxCapacity] = React.useState("");
  const [minWeight, setMinWeight] = React.useState("");
  const [maxWeight, setMaxWeight] = React.useState("");
  const [minHeight, setMinHeight] = React.useState("");
  const [maxHeight, setMaxHeight] = React.useState("");
  const [axle, setAxle] = React.useState({
    rear: false,
    front: false,
    stub: false,
    semi: false,
  });

  React.useEffect(() => {
    if (resetFilter) {
      handleClear();
      setReset(false);
    }
  }, [resetFilter]);

  const handleCountriesModal = () => {
    setCountriesModal(true);
  };

  const handleCheckbox = (key) => (e) => {
    setAxle({ ...axle, [key]: e.target.checked });
  };

  const handleClear = () => {
    setMinPrice("");
    setMaxPrice("");
    setMinCapacity("");
    setMaxCapacity("");
    setMinWeight("");
    setMinHeight("");
    setMaxHeight("");
    const newAxle = { ...axle };
    Object.keys(axle).forEach((key) => (newAxle[key] = false));
    setAxle(newAxle);
    setSelectedCountries([]);
  };

  const handleKeyWordChange = (e) => {
    if (e.key === "Enter") {
      setKeywords([...keywords, keyword]);
      setKeyword("");
    }
  };

  const handleKeywordDelete = (kw) => {
    setKeywords(keywords.filter((k) => k != kw));
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "600px",
            maxHeight: "600px",
            bgcolor: "#FFFFFF",
            boxShadow:
              "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
            outline: "none",
            borderRadius: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              padding: "24px",
            }}
          >
            <CloseIcon
              onClick={handleClose}
              sx={{
                color: "text.primary",
                marginLeft: "2px",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
            />
            <Typography
              variant="subtitle1"
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              color="black"
              sx={{
                margin: "auto",
              }}
            >
              More Filters
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              backgroundColor: "#D6D6D6",
            }}
          ></Box>
          <Box
            sx={{
              height: "430px",
              padding: "24px",
              overflowY: "scroll",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Heading text="Price" />
            <Box
              sx={{
                display: "flex",
                columnGap: "9px",
                marginTop: "24px",
                alignItems: "center",
              }}
            >
              <Fi
                value={minPrice}
                handleChange={(e) => setMinPrice(e.target.value)}
                label="Min. Price"
                height="46.29px"
                sx={{ width: "46.8%" }}
                select={true}
              >
                {price.map((p) => (
                  <MenuItem key={p} value={p}>
                    {p}
                  </MenuItem>
                ))}
              </Fi>
              <Box
                sx={{
                  width: "16px",
                  height: "2px",
                  backgroundColor: "#BFBFBF",
                }}
              ></Box>
              <Fi
                value={maxPrice}
                handleChange={(e) => setMaxPrice(e.target.value)}
                label="Max. Price"
                height="46.29px"
                endIcon={<KeyboardArrowDownIcon sx={{ color: "#808080" }} />}
                sx={{ width: "46.8%" }}
                select={true}
              >
                {price.map((p) => (
                  <MenuItem key={p} value={p}>
                    {p}
                  </MenuItem>
                ))}
              </Fi>
            </Box>
            <Separator />
            <Heading text="Location" />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "24px",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
              onClick={handleCountriesModal}
            >
              <Box>
                <Typography
                  variant="subtitle1"
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="600"
                  lineHeight="24px"
                  color="text.primary"
                  sx={{ marginBottom: "4px" }}
                >
                  Country
                </Typography>
                <Typography
                  variant="body1"
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="24px"
                  color={
                    selectedCountries.length > 0 ? "primary.main" : "#616161"
                  }
                >
                  {selectedCountries.length > 0
                    ? `${selectedCountries.slice(0, 5).join(", ")}${
                        selectedCountries.length - 4 > 0
                          ? ` and ${selectedCountries.length - 4} more`
                          : ""
                      }`
                    : "You can add multiple countries to filter"}
                </Typography>
              </Box>
              <KeyboardArrowRightIcon sx={{ color: "#616161" }} />
            </Box>
            <Separator />
            <Heading text="Capacity" />
            <Box
              sx={{
                display: "flex",
                columnGap: "9px",
                marginTop: "24px",
                alignItems: "center",
              }}
            >
              <Fi
                value={minCapacity}
                handleChange={(e) => setMinCapacity(e.target.value)}
                label="Min. Capacity"
                height="46.29px"
                sx={{ width: "46.8%" }}
                select={true}
              >
                {capacity.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </Fi>
              <Box
                sx={{
                  width: "16px",
                  height: "2px",
                  backgroundColor: "#BFBFBF",
                }}
              ></Box>
              <Fi
                value={maxCapacity}
                handleChange={(e) => setMaxCapacity(e.target.value)}
                label="Max. Capacity"
                height="46.29px"
                select={true}
                sx={{ width: "46.8%" }}
              >
                {capacity.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </Fi>
            </Box>
            <Separator />
            <Heading text="Axle configration" />
            <Box
              sx={{
                display: "flex",
                columnGap: "168px",
                marginTop: "24px",
                rowGap: "16px",
              }}
            >
              <Box>
                <CheckboxText
                  text="Rear Axles"
                  value={axle["rear"]}
                  handleChange={handleCheckbox("rear")}
                />
                <CheckboxText
                  text="Stub Axle"
                  value={axle["stub"]}
                  handleChange={handleCheckbox("stub")}
                />
              </Box>
              <Box>
                <CheckboxText
                  text="Front Axle"
                  value={axle["front"]}
                  handleChange={handleCheckbox("front")}
                />
                <CheckboxText
                  text="Semi-Floating Axle"
                  value={axle["semi"]}
                  handleChange={handleCheckbox("semi")}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                columnGap: "14px",
                alignItems: "center",
                marginTop: "26px",
              }}
            >
              <Typography
                fontFamily="Inter"
                fontSize="14px"
                fontWeight="400"
                lineHeight="20px"
                color="text.primary"
                sx={{ textDecoration: "underline" }}
              >
                Show all axle configrations
              </Typography>
              <KeyboardArrowDownIcon sx={{ color: "primary.main" }} />
            </Box>
            <Separator />
            <Heading text="Lifting" />
            <Lift
              text="Weight (KG)"
              label="Weight"
              minVal={minWeight}
              maxVal={maxWeight}
              handleMinChange={(e) => setMinWeight(e.target.value)}
              handleMaxChange={(e) => setMaxWeight(e.target.value)}
              values={weight}
            />
            <Lift
              text="Height (Meter)"
              label="Height"
              minVal={minHeight}
              maxVal={maxHeight}
              handleMinChange={(e) => setMinHeight(e.target.value)}
              handleMaxChange={(e) => setMaxHeight(e.target.value)}
              values={height}
            />
            <Separator />
            <Heading text="Add keywords" />
            <Fi
              value={keyword}
              handleKeyChange={handleKeyWordChange}
              handleChange={(e) => setKeyword(e.target.value)}
              label="Add keyword"
              height="46.29px"
              sx={{ width: "100%", marginY: "24px" }}
              filled={false}
            />

            <Box
              ref={ref}
              onMouseDown={onMouseDown}
              sx={{
                overflow: "auto",
                whiteSpace: "nowrap",
                "::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {keywords.length > 0 &&
                keywords.map((kw, i) => (
                  <Button
                    key={i}
                    variant="outlined"
                    sx={{
                      backgroundColor: "#255CCE1A",
                      borderColor: "#255CCE",
                      padding: "8px",
                      height: "36px",
                      marginRight: "8px",
                      "&:hover": {
                        backgroundColor: "#255CCE1A",
                        borderColor: "#255CCE",
                      },
                      "&:hover svg": {
                        color: "text.primary",
                      },
                    }}
                    size="lg"
                    txColor="text.primary"
                    typoVariant="body1"
                    fontWeight="400"
                    hoverTxColor="text.primary"
                    endIcon={
                      <CloseIcon
                        onClick={() => handleKeywordDelete(kw)}
                        sx={{
                          color: "text.primary",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                    }
                  >
                    {kw}
                  </Button>
                ))}
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              backgroundColor: "#D6D6D6",
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "24px",
              width: "100%",
            }}
          >
            <Typography
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              color="text.primary"
              sx={{
                textDecoration: "underline",
                "&:hover": { cursor: "pointer" },
              }}
              onClick={handleClear}
            >
              Clear All
            </Typography>
            <Button
              variant="contained"
              size="lg"
              txColor="text.primary"
              bgColor="#F9D548"
              sx={{ height: "48px", width: "205px", boxShadow: "none" }}
              onClick={handleClose}
              hoverBg="#F3C04F"
            >
              Search 150 machinery
            </Button>
          </Box>
        </Box>
      </Modal>
      <CountriesModal
        selectedCountries={selectedCountries}
        setSelectedCountries={setSelectedCountries}
        open={countriesModal}
        setOpen={setCountriesModal}
        setParentOpen={setOpen}
      />
    </>
  );
}

function Lift({
  text,
  minVal,
  maxVal,
  label,
  handleMinChange,
  handleMaxChange,
  values,
}) {
  return (
    <Box>
      <Typography
        variant="subtitle1"
        fontFamily="Inter"
        fontSize="16px"
        fontWeight="600"
        lineHeight="24px"
        color="text.primary"
        sx={{ marginY: "24px" }}
      >
        Lifting {text}
      </Typography>
      <Box
        sx={{
          display: "flex",
          columnGap: "9px",
          marginTop: "24px",
          alignItems: "center",
        }}
      >
        <Fi
          value={minVal}
          handleChange={handleMinChange}
          label={`Min. ${label}`}
          height="46.29px"
          select={true}
          sx={{ width: "46.8%" }}
        >
          {values.map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </Fi>
        <Box
          sx={{ width: "16px", height: "2px", backgroundColor: "#BFBFBF" }}
        ></Box>
        <Fi
          value={maxVal}
          handleChange={handleMaxChange}
          label={`Max. ${label}`}
          height="46.29px"
          select={true}
          sx={{ width: "46.8%" }}
        >
          {values.map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
        </Fi>
      </Box>
    </Box>
  );
}

function CheckboxText({ text, value, handleChange }) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={handleChange}
          sx={{
            color: "#6200EE",
            "&.Mui-checked": {
              color: "#6200EE",
            },
          }}
        />
      }
      label={
        <Typography
          variant="body1"
          fontFamily="Inter"
          fontSize="16px"
          fontWeight="400"
          lineHeight="24px"
          color="text.primary"
        >
          {text}
        </Typography>
      }
    />
  );
}

function Separator() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "1px",
        backgroundColor: "#D6D6D6",
        margin: "24px 0px",
      }}
    ></Box>
  );
}

function Heading({ text }) {
  return (
    <Typography
      variant="subtitle1"
      fontFamily="Inter"
      fontSize="22px"
      fontWeight="600"
      lineHeight="26px"
      color="text.primary"
    >
      {text}
    </Typography>
  );
}
